/**
 * RukuNaSrce API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FamilyResponseDto } from './familyResponseDto';
import { CategoryResponseDto } from './categoryResponseDto';


export interface DonationResponseDto { 
    id?: number | null;
    createdOn?: string | null;
    updatedOn?: string | null;
    deletedOn?: string | null;
    readonly isDeleted?: boolean;
    readonly isNewRecord?: boolean;
    name?: string | null;
    categoryId?: number;
    category?: CategoryResponseDto;
    familyId?: number;
    family?: FamilyResponseDto;
    note?: string | null;
    donationDate?: string | null;
}

